import { render, staticRenderFns } from "./RolesAddEditModal.vue?vue&type=template&id=dd1a231e&"
import script from "./RolesAddEditModal.vue?vue&type=script&lang=js&"
export * from "./RolesAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports